export class IntakeDate {
    startDate: string;
    formattedStartDate: string; // MMM YYYY
}